export enum HoldingFeeCycleStatus {
  PAID = "Paid",
  WAIVED = "Waived",
}
